"use client";

import { Button } from "@tosize/ui";
import type { ComponentProps } from "react";
import { useBetterAction } from "~/hooks/useBetterAction";
import type { LangParams } from "../../layout";
import { logout } from "./actions";

type LogoutButtonProps = ComponentProps<typeof Button> & LangParams;

export const LogoutButton = ({ lang, ...props }: LogoutButtonProps) => {
	const { executeAsync, isPending } = useBetterAction(logout);

	return (
		<Button type="button" isLoading={isPending} onClick={() => executeAsync({ lang })} {...props} />
	);
};
